import { useRef } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { NotebookPage } from "./NotebookPage.tsx";
import { notebookStore } from "./notebookStore.ts";
import { Note } from "@models/note.model.ts";
import { useDocumentTitle } from "@/shared/hooks/useDocumentTitle";

export default function NotebookPopout() {
    useDocumentTitle("Notebook");
    const { notebookId } = useParams<{ notebookId: string }>();
    const [searchParams] = useSearchParams();
    const noteId = searchParams.get("noteId");
    const initialized = useRef(false);

    if (!initialized.current && noteId) {
        const note = new Note();
        note.id = Number(noteId);
        notebookStore.selectedNote = note;
        initialized.current = true;
    }

    if (!notebookId) return null;

    // The popout has no engagement shell around it, so it supplies the pane
    // background and the height that .notes fills.
    return (
        <div style={{ height: "100vh", padding: 16, background: "#F0F1F6" }}>
            <NotebookPage notebookId={Number(notebookId)} />
        </div>
    );
}
